import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify'

import TableFleet from './components/TableFleet'
import UserPortal from './components/UserPortal'
import ErrorPage from './components/ErrorPage'
import Authentification from './components/Authentification'

const routes = [
  { path: '/admin', component: TableFleet, meta: { requiresAdmin: true } },
  { path: '/auth', component: Authentification },
  { path: '/error', component: ErrorPage },
  { path: '/fleet/:id', component: UserPortal, name: "fleet", meta: { requiresUser: true } },
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeResolve(async (to, _, next) => {
  try {
    const record = to.matched.find(record => record.meta.requiresAdmin || record.meta.requiresUser)
    if (record) {
      const user = await Auth.currentAuthenticatedUser();
      const roleToFind = record.meta.requiresAdmin ? "ViLinkBastionAdmin" : "ViLinkBastionUser";
      if (!user.attributes['custom:rolevilink'].includes(roleToFind)) {
        next({
          path: '/error'
        });
      }
      next()
    }

  }
  catch (error) {
  console.log(error)
    localStorage.setItem("lastRoute", to.path)
    next({
      path: '/auth',
    });
  }
  next()
})

export default router